export const statusFinancing = (status, content) => {
  switch (status) {
    case "pending":
      return <div className="color-status primary">{content}</div>;

    case "in_progress":
      return <div className="color-status info">{content}</div>;
    case "accpeted":
      return <div className="color-status success">{content}</div>;
    case "rejected":
      return <div className="color-status danger">{content}</div>;
    default:
      return <div className="color-status warning">{content}</div>;
  }
};
